<template>
  <button class="modal-popup-button" :class="{ icon, small, disabled }">
    <slot>
      <SvgIcon v-if="icon" :name="icon" :size="iconSize || 24" />
    </slot>
  </button>
</template>

<script setup lang="ts">
import SvgIcon from '@/components/common/SvgIcon.vue'

defineProps<{
  icon?: string
  iconSize?: number
  small?: boolean
  disabled?: boolean
}>()
</script>

<style scoped lang="postcss">
.modal-popup-button {
  @apply font-extrabold italic text-lg-button text-gray-600 bg-white border border-gray-200 py-3 px-8 rounded-xl mx-1 mb-1;

  &.icon {
    @apply px-3 rounded-full m-0;
  }

  &:not(.disabled) {
    &:hover {
      @apply bg-gray-100 border-gray-300 text-gray-900;
    }

    &:active {
      @apply bg-gray-200 border-gray-400 text-gray-900;
    }
  }

  &.small {
    @apply text-base py-2 px-5;
  }

  &.disabled {
    @apply cursor-not-allowed opacity-50;
  }
}
</style>
